import request from '@/utils/request'

// 查询类目分类列表
export function listClass(query) {
    return request({
        url: '/plat/class/list',
        method: 'get',
        params: query
    })
}

// 查询类目分类详细
export function getClass(id) {
    return request({
        url: '/plat/class/' + id,
        method: 'get'
    })
}

// 新增类目分类
export function addClass(data) {
    return request({
        url: '/plat/class',
        method: 'post',
        data: data
    })
}

// 修改类目分类
export function updateClass(data) {
    return request({
        url: '/plat/class',
        method: 'put',
        data: data
    })
}

// 删除类目分类
export function delClass(id) {
    return request({
        url: '/plat/class/' + id,
        method: 'delete'
    })
}

// 导出类目分类
export function exportClass(query) {
    return request({
        url: '/plat/class/export',
        method: 'get',
        params: query
    })
}


// 查询类目分类列表
export function getClassList(query) {
    return request({
        url: '/plat/class/getList',
        method: 'get',
        params: query
    })
}

// 查询店铺授权
export function listPlat(data) {
    return request({
        url: '/plat/plat/list',
        method: 'post',
        data: data
    })
}

export function getShopList() {
    return request({
        url:'/plat/shopList',
        method:'get'
    })
}
// 添加店铺授权
export function submitFormAdd(data) {
    return request({
        url: '/plat/plat/add',
        method: 'post',
        data: data
    })
}
// 修改店铺授权
export function submitFormSave(data) {
    return request({
        url: '/plat/plat/save',
        method: 'post',
        data: data
    })
}
//删除店铺授权
export function deletePlat(data) {
    return request({
        url: '/plat/plat/delete',
        method: 'post',
        data: data
    })
}
